import React, { Fragment, useState } from "react";
import { FaEdit, FaEye, FaRegCheckCircle, FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import { TD } from "styled/table";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import Delete from "./delete";
import Edit from "./edit";
import { Button } from "styled";
import { FcApprove } from "react-icons/fc";
import { BsCheck2Circle } from "react-icons/bs";
import Modal from "components/Modal";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";


const ViewList = ({ data, index, approveRequest, getData, page, setPage }) => {
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(null)
  const currentUser = useSelector((state) => state.user.currentUser);
  console.log(currentUser.userRole.permissions, checkPermission(currentUser, [permissions.approve_dtp_plan]))

  return (
    <Fragment>
      <tr key={data._id} className={`${index % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{(page - 1) * 20 + index + 1}</TD>
        <TD>{data.createdBy?.name}</TD>
        <TD>{data.quarter}</TD>
        <TD>
          {data.createdAt
            ? new Date(data.createdAt).toLocaleDateString("en-GB").replace(/\//g, '-')
            : ""}
        </TD>
        <TD>{data.status}</TD>
        <TD>
          {
            <div className="flex flex-row">
              {checkPermission([permissions.edit_dtp_plan], currentUser) ? (
                <button
                  onClick={() => setShowEditModel(true)}
                  className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
                >
                  <FaEdit />
                </button>
              ) : (
                <div className="px-1 flex justify-center align-center mt-2"></div>
              )}
              <button
                onClick={() => setShowViewModel(true)}
                className="p-2 m-1 rounded-md bg-yellow-500 hover:bg-yellow-600 text-white"
              >
                <FaEye />
              </button>
              {data.status!== "Approved" && checkPermission([permissions.delete_dtp_plan], currentUser) ? (
                <button
                  onClick={() => setShowDeleteModel(true)}
                  className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
                >
                  <FaTrash />
                </button>
              ) : (
                <div className="px-1 flex justify-center align-center mt-2"></div>
              )}
              {data.status !== "Approved" &&
              checkPermission([permissions.approve_dtp_plan], currentUser) ? (
                <button
                  className="p-2 m-1 rounded-md bg-blue-500 hover:bg-blue-600 text-white"
                  disabled={data.status === "Approved"}
                  onClick={() => {
                    setShowApproveModal(data._id);
                  }}
                >
                  {" "}
                  <FaRegCheckCircle />{" "}
                </button>
              ) : (
                <></>
              )}
            </div>
          }
        </TD>
      </tr>
      {showViewModel && (
        <Edit
          data={data}
          desable={true}
          handleClick={() => setShowViewModel(false)}
        />
      )}
      {showApproveModal && (
        <Modal
          handleClick={() => {
            setShowApproveModal(null);
          }}
          title={"Approve DTP Plan"}
          className="max-w-xl"
        >
          <div className="p-4">
            <p className="text-red-500 p-5 text-center">
              Are you sure you want to Approve this DTP Plan
            </p>

            <div className="px-5 flex justify-end items-center gap-4 pb-4 flex-wrap sm:w-full">
              <Button bgSecondary onClick={() => setShowApproveModal(null)}>
                No
              </Button>
              <Button
                type="button"
                bgPrimary
                onClick={() => approveRequest(showApproveModal)}
              >
                Yes
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {showEditModel && (
        <Edit
          data={data}
          handleClick={() => {
            setShowEditModel(false);
            getData();
          }}
        />
      )}

      {showDeleteModel && (
        <Delete id={data._id} handleClick={() => setShowDeleteModel(false)} getData={getData} />
      )}
    </Fragment>
  );
};

export default ViewList;
